import React from 'react'
import { useContext } from './Context'
import { useAddBoardItem } from './useAddBoardItem'
import { SaveCancelButtons } from '@ztechapps/webui.button'

export const SaveCancelBoardItemButton = () => {
  const { onClose, hasSelected } = useContext()
  const { onSave } = useAddBoardItem()

  return <SaveCancelButtons disabled={!hasSelected} onSave={onSave} onCancel={onClose} />
}
